<mat-form-field class="input-time" appearance="fill" [formGroup]="form" fxFlex>
  <mat-label>{{ measure.description }}</mat-label>
  <input *ngIf="!isNumberQuestion" matInput formControlName="{{ measure.id }}" placerholder="" value="">
  <input *ngIf="isNumberQuestion" type="number" inputmode="numeric" matInput formControlName="{{ measure.id }}" placerholder="" value="">
</mat-form-field>
